export default __webpack_public_path__ + "static/media/36I-102790_-15917_0.69612e4b.jpg";